export const MAX_ASK_VOLLEY_THREAD_TURNS = 6;
